// modules
import { createSelector } from 'reselect'
import { get } from 'lodash'

export const caregiverGamification$ = (state = {}) =>
  get(state, ['caregiver', 'gamification'], {})

export const caregiverGamificationVault$ = createSelector(
  caregiverGamification$,
  (caregiverGamification = {}) => get(caregiverGamification, ['vault'], {})
)

export const caregiverGamificationHistory$ = createSelector(
  caregiverGamification$,
  (caregiverGamification = {}) => get(caregiverGamification, ['history'], [])
)
